/** 批量打标模式：与后端 TagBatchBindCmd.mode 保持一致 */
export const TAG_BIND_MODE = {
  APPEND: 'append',
  REPLACE: 'replace',
  REMOVE: 'remove',
}

export const TAG_BIND_MODE_OPTIONS = [
  {
    value: TAG_BIND_MODE.APPEND,
    label: '追加',
    tip: '在原有 Tag 上增加，不删除已有 Tag',
  },
  {
    value: TAG_BIND_MODE.REPLACE,
    label: '覆盖',
    tip: '替换为所选 Tag；不选 Tag 将清空全部',
  },
  {
    value: TAG_BIND_MODE.REMOVE,
    label: '移除',
    tip: '从原有 Tag 中移除所选 Tag',
  },
]

export const GENERIC_RESOURCE_TYPE = 21

/** 批量打标层进向导步骤：scope → method → page-tag | excel-tag */
export const BATCH_TAG_WIZARD_STEP = {
  SCOPE: 'scope',
  METHOD: 'method',
  PAGE_TAG: 'page-tag',
  EXCEL_TAG: 'excel-tag',
}

/** v2 打标表固定列（不含随 mode 变化的操作列） */
export const EXCEL_BASE_COLUMNS = ['title', 'resourceType', 'key', 'currentTags']

/** 操作列字段名（导出/解析统一） */
export const EXCEL_OPERATION_FIELD = 'operationTags'

/** 各 mode 对应的操作列表头文案 */
export const EXCEL_MODE_OPERATION_HEADERS = {
  [TAG_BIND_MODE.APPEND]: '追加 Tag（仅改此列）',
  [TAG_BIND_MODE.REPLACE]: '覆盖 Tag（仅改此列）',
  [TAG_BIND_MODE.REMOVE]: '删除 Tag（仅改此列）',
}

/**
 * 打标表列头别名：兼容 v1 英文表头与 v2 中文表头。
 */
export const EXCEL_COLUMN_FIELD_ALIASES = {
  title: ['title', '资源名称'],
  resourceType: ['resourceType', '资源类型'],
  key: ['key', '资源 key（勿改）', '资源 key', '资源key（勿改）'],
  currentTags: ['currentTags', '当前 Tag（参考，勿改）', '当前 Tag', '当前Tag（参考，勿改）'],
  operationTags: [
    'operationTags',
    '追加 Tag（仅改此列）',
    '覆盖 Tag（仅改此列）',
    '删除 Tag（仅改此列）',
    // v1 兼容
    'tag',
    'Tag（仅改此列）',
    'Tag',
    'tag（仅改此列）',
  ],
}

/** @deprecated v1 四列模板，仅作旧表头检测 */
export const EXCEL_TEMPLATE_COLUMNS = ['title', 'resourceType', 'key', 'tag']

export function getOperationHeaderForMode(mode) {
  return EXCEL_MODE_OPERATION_HEADERS[mode] || ''
}

export function getModeLabel(mode) {
  const item = TAG_BIND_MODE_OPTIONS.find((opt) => opt.value === mode)
  return item ? item.label : mode
}
